export default "__VITE_ASSET__5f7a831a__"